import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, intro, image, alt, testId }) => {
  return (
    <section
      data-testid={testId}
      className="relative h-[68vh] min-h-[460px] w-full overflow-hidden"
    >
      <img
        src={image}
        alt={alt}
        className="absolute inset-0 h-full w-full object-cover animate-fade-in"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-aveden-black/80 via-aveden-black/25 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-aveden-black/90 via-aveden-black/10 to-transparent" />
      <div className="relative h-full mx-auto max-w-[1600px] px-6 sm:px-10 lg:px-16 flex items-end pb-20 lg:pb-28">
        <div className="max-w-3xl animate-fade-up">
          {eyebrow && (
            <p className="font-sans text-[11px] tracking-[0.4em] uppercase text-aveden-gold mb-6">
              {eyebrow}
            </p>
          )}
          <h1 className="font-serif font-light text-aveden-white text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight uppercase">
            {title}
          </h1>
          <div className="h-px w-16 bg-aveden-gold mt-9 mb-7" />
          {intro && (
            <p className="font-sans font-light text-aveden-gray text-base sm:text-lg leading-relaxed max-w-2xl">
              {intro}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
